import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MDBDataTable } from "mdbreact";
import moment from "moment";
import MainApp from "../../../layouts/MainApp";
import PrimaryLoader from '../../../includes/Loaders/PrimaryLoader';
import CreateThirdPartyToken from "./CreateThirdPartyToken";
import { adminActions } from "../../../../redux/actions";

export default function ThirdPartyToken() {
  const thirdPartyToken = useSelector((state) => state.admin.thirdPartyToken);
  const loading = useSelector((state) => state.admin.getSettingsLoader);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(adminActions.getThirdPartyToken());
  }, [dispatch]);

  function createTableData() {
    let dataToMap = thirdPartyToken;
    if (Array.isArray(dataToMap)) {
      let outputArray = [];
      dataToMap.map((token, i) => {
        let singleRowArray = {
          created: moment(token.created).format("lll"),
          label: token.label,
          token: token.token,
          // actions: <span>delete</span>,
        };
        outputArray.push(singleRowArray);
        return true;
      });
      return outputArray;
    }
  }
  const dataSet = createTableData();

  const data = {
    columns: [
      {
        label: "Created at",
        field: "created",
        sort: "asc",
        width: 100,
      },
      {
        label: "Label",
        field: "label",
        sort: "asc",
        width: 200,
      },
      {
        label: "Token",
        field: "token",
        sort: "asc",
        width: 500,
      },
    ],
    rows: dataSet,
  };

  return (
    <MainApp>
      {loading ? (
        <PrimaryLoader />
      ) : (
        <div className="main-content-padding">
          <div className="main-content">
            <div className="mb-2  d-flex justify-content-between ">
              <h1 className="mr-2">Third party token</h1>
              <CreateThirdPartyToken />
            </div>
            <h5 className="mb-3">
              This allows a third party to create and edit orders for your
              company using the generated token{" "}
            </h5>
            <div className="separator-breadcrumb border-top" />
            <br></br>

            <div className="mb-4">
              <MDBDataTable
                responsive
                searching={false}
                entries={5}
                entriesOptions={[5, 8, 15]}
                striped
                bordered
                hover
                noBottomColumns
                data={data}
              />
            </div>
          </div>
        </div>
      )}
    </MainApp>
  );
}
